export const RESET_ALL_PERSISTED_STATE = 'RESET_ALL_PERSISTED_STATE';
